import MyPageSectionFoodAndDrink from './MyPageSectionFoodAndDrink';
export * from './MyPageSectionFoodAndDrink';
export default MyPageSectionFoodAndDrink